import { YStack } from 'smoothie';

import { DRAG_PINK, GOAL_DRAG_STROKE_PX } from './goalsWaterfallConstants';

export const DropLine = () => (
    <YStack
        height={GOAL_DRAG_STROKE_PX}
        backgroundColor={DRAG_PINK}
        borderRadius={GOAL_DRAG_STROKE_PX}
        marginVertical={4}
        flexShrink={0}
    />
);
